/* eslint-disable import/prefer-default-export */

export const REACT_APP_API_URL = 'https://quality.cogniable.us/apis'
// export const REACT_APP_API_URL = 'https://quality.cogniable.us/apis'
// export const REACT_APP_API_URL = 'https://quality.cogniable.us/apis'
// export const REACT_APP_API_URL = 'https://quality.cogniable.us/apis'
